import { Injectable } from '@angular/core';
import { AuthUserModel } from 'projects/core/src/lib/models/authuser.model';
import { BaseTokenService } from 'projects/core/src/lib/services/base-token.service';

@Injectable({
  providedIn: 'root'
})
export class TokenService extends BaseTokenService {

  protected id = 'acr_runner';

  public isModerator(): boolean {
    const user = this.getAuthUser();
    if (user !== null) {
      return user.roles.filter((role: string) => {
        return role.includes('moderator') === true;
      }).length > 0;
    } else {
      return false;
    }
  }

  public isObserver(): boolean {
    const user = this.getAuthUser();
    if (user !== null) {
      return user.roles.filter((role: string) => {
        return role.includes('observer') === true;
      }).length > 0;
    } else {
      return false;
    }
  }

  public isSilentObserver(): boolean {
    const user = this.getAuthUser();
    if (user !== null) {
      return this.isObserver() && user.subtype === 'silent';
    } else {
      return false;
    }
  }

  public getHashedId(): string {
    const user = this.getAuthUser();
    return (user !== null && user.hashed_id) ? user.hashed_id : '';
  }

  public getAc(): number | null {
    const payload = this.getPayload();
    return payload.ac;
  }

  public getAuthUser(): AuthUserModel | null {
    const payload = this.getPayload();
    return (payload !== null && payload.user) ? new AuthUserModel().deserialize(payload.user) : null;
  }

}
